module.exports = __webpack_public_path__ + "img/SwapTokenSuccess.a4356d7a.svg";